import { render, staticRenderFns } from "./EmployeeEdit.vue?vue&type=template&id=99d5ae40&scoped=true"
import script from "./EmployeeEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeEdit.vue?vue&type=script&lang=js"
import style0 from "./EmployeeEdit.vue?vue&type=style&index=0&id=99d5ae40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d5ae40",
  null
  
)

export default component.exports